import { useMemo, useState } from "react";
import { useNotification } from 'hooks'
import { Table } from 'components/core-ui/Table'
import { makeCoreGetRequest } from "utils/api";
import { toTableGETUrl } from 'components/core-ui/Table/serializers'
import { formatErrorMessage } from 'utils/formatting'
import { columns, drawerFilters } from './helpers'
import { toTableRowItems } from './serializers'
import s from '../../../commonStyles.modules.scss'
import {
  getMetiFamiliesOptions,
  getMetiSubFamiliesOptions,
  getMetiUBOptions,
  getRayonsOptions,
  getShopOptions,
  getShopTypesOptions
} from '../../api'

const ShortDlcProducts = () => {
  const { showNotification } = useNotification()

  const [tableItems, setTableItems] = useState<DSDLCProducts[]>([])
  const [totalCount, setTotalCount] = useState<number>(0)
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [shouldRefreshData, setShouldRefreshData] = useState<boolean>(false)

  const fetchData = async ({ page, rowsPerPage, order, orderBy, tableFilters }) => {
    setIsLoading(true)
    try {
      const response = await makeCoreGetRequest(
        toTableGETUrl({
          url: '/shop-reception/ds-short-dlc',
          tableFilters,
          page,
          rowsPerPage,
          order,
          orderBy
        })
      )

      setTableItems(toTableRowItems(response.list))
      setTotalCount(response?.page?.totalCount || 0)
    } catch (error) {
      showNotification({
        message: `A aparut o eroare la obtinerea datelor din tabel. ${formatErrorMessage(error)}`,
        type: 'error'
      })
    } finally {
      setIsLoading(false)
    }
  }

  const { data: shopTypes } = getShopTypesOptions(showNotification)
  const { data: shopCodes } = getShopOptions(showNotification)
  const { data: metiRayons } = getRayonsOptions(showNotification)
  const { data: metiFamilies } = getMetiFamiliesOptions(showNotification)
  const { data: metiSubfamilies } = getMetiSubFamiliesOptions(showNotification)
  const { data: metiUB } = getMetiUBOptions(showNotification)

  const combineShopOptions = (shopTypes, shopCodes) => {
    const mappedShopTypes = (shopTypes || []).map(({ label, value }) => ({
      label: label,
      value: value
    }));

    return [
      ...mappedShopTypes,
      ...(shopCodes || [])
    ];
  };

  const combinedShopOptions = useMemo(
    () => combineShopOptions(shopTypes, shopCodes),
    [shopTypes, shopCodes]
  )

  return (
    <div className={s.mainContainer}>
      <Table
        hideCheckbox
        columns={columns}
        items={tableItems}
        fetchData={fetchData}
        isLoading={isLoading}
        totalCount={totalCount}
        filters={drawerFilters(combinedShopOptions, metiRayons, metiFamilies, metiSubfamilies, metiUB)}
        shouldRefreshData={shouldRefreshData}
        setShouldRefreshData={setShouldRefreshData}
        rowActionsWidth="130px"
        filtersLabel="Filtreaza"
        filtersButtonLabel="Filtreaza"
        appliedFiltersLabel="Filtre"
        cancelFiltersButtonLabel="Anuleaza"
        applyFiltersButtonLabel="Aplica"
        rowsPerPage={10}
        rowsPerPageOptions={[10, 25, 50]}
      />
    </div>
  )
}

export default ShortDlcProducts
